/* dp-menu: editorial mobile drawer behaviour. */
(function () {
  var RV_KEY = 'dp_recently_viewed';
  var PRX = /\/products\/([^\/?#.]+)/;
  function rvGet() { try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; } }
  /* Record product page views (handles only). */
  (function () {
    var m = location.pathname.match(PRX);
    if (!m) return;
    var h = decodeURIComponent(m[1]);
    try { var l = rvGet().filter(function (x) { return x !== h; }); l.unshift(h); localStorage.setItem(RV_KEY, JSON.stringify(l.slice(0, 12))); } catch (e) {}
  })();
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML.replace(/"/g, '&quot;'); }
  function img(u, w) { if (!u) return ''; u = u.indexOf('//') === 0 ? 'https:' + u : u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var rvSig = null;
  function renderRV(root) {
    var box = root.querySelector('[data-dp-rv]'), row = root.querySelector('[data-dp-rv-row]');
    if (!box || !row) return;
    var cur = (location.pathname.match(PRX) || [])[1];
    var list = rvGet().filter(function (h) { return h !== cur; }).slice(0, 6);
    var sig = list.join(',');
    if (sig === rvSig) return; rvSig = sig;
    if (!list.length) { box.hidden = true; row.innerHTML = ''; return; }
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      /* Only handle, title, vendor and image are read. Prices are never used. */
      var html = ps.filter(function (p) { return p && p.handle; }).map(function (p) {
        var src = p.featured_image || (p.images && p.images[0]);
        var t = String(p.title || '').replace(/\s?[\u2013\u2014]\s?/g, ' ');
        return '<a class="dp-rv-item" href="/products/' + encodeURIComponent(p.handle) + '">' +
          (src ? '<span class="dp-ph"><img src="' + esc(img(src, 600)) + '" srcset="' + esc(img(src, 300)) + ' 300w, ' + esc(img(src, 600)) + ' 600w" sizes="38vw" alt="' + esc(t) + '" loading="lazy"></span>' : '') +
          '<div class="dp-br">' + esc(p.vendor) + '</div><div class="dp-pn dp-serif">' + esc(t) + '</div></a>';
      }).join('');
      row.innerHTML = html; box.hidden = !html;
    });
  }
  /* Hide brands that have no live products in that collection (uses the collection page's Brand filter). */
  function pruneAZ(panel) {
    var ul = panel.querySelector('[data-dp-az]');
    if (!ul || ul.dataset.dpPruned) return;
    ul.dataset.dpPruned = '1';
    fetch(ul.dataset.dpAz).then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) {
      var d = new DOMParser().parseFromString(t, 'text/html'), ok = {};
      d.querySelectorAll('input[name="filter.p.vendor"]').forEach(function (i) { ok[i.value] = 1; });
      if (!Object.keys(ok).length) return;
      var head = null, any = false;
      [].forEach.call(ul.children, function (li) {
        if (li.classList.contains('dp-az-l')) { if (head) head.hidden = !any; head = li; any = false; return; }
        li.hidden = !ok[li.dataset.v]; if (!li.hidden) any = true;
      });
      if (head) head.hidden = !any;
    }).catch(function () {});
  }
  function stagger(root) {
    var main = root.querySelector('.dp-panel--main');
    if (!main) return;
    main.querySelectorAll('.dp-search, .dp-btn, .dp-list > li, .dp-h, .dp-car, .dp-dots, .dp-rv, .dp-util > li, .dp-help').forEach(function (el, i) {
      el.setAttribute('data-dp-in', ''); el.style.setProperty('--dp-i', Math.min(i, 14));
    });
    root.classList.remove('dp-anim'); void root.offsetWidth; root.classList.add('dp-anim');
  }

  /* v5: predictive search. Uses /search/suggest.json; price fields are ignored on purpose. */
  var DP_POP = [['Cartier','cartier'],['Jacques Marie Mage','jacques-marie-mage'],['Kuboraum','kuboraum'],['DITA','dita'],['Saint Laurent','saint-laurent'],['Peter and May','peter-and-may']];
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
  function hl(t, q) {
    var words = q.trim().split(/\s+/).filter(Boolean).map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    var s = esc(t); if (!words.length) return s;
    return s.replace(new RegExp('(' + words.map(esc).join('|') + ')', 'gi'), '<mark>$1</mark>');
  }
  function clean(u) { return String(u || '').split('?')[0]; }
  function initPS(root) {
    var input = root.querySelector('.dp-search input[type=search]'), box = root.querySelector('[data-dp-ps]');
    var main = root.querySelector('.dp-panel--main');
    if (!input || !box || !main) return;
    var timer, ctl, cache = {}, base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function off() { box.hidden = true; box.innerHTML = ''; main.classList.remove('dp-ps-on'); }
    function render(q, r) {
      var p = (r.products || []).slice(0, 6), c = r.collections || [], s = (r.queries || []).slice(0, 4), h = '';
      var all = base + 'search?type=product&q=' + encodeURIComponent(q);
      if (!p.length && !c.length && !s.length) {
        h = '<p class="dp-ps-empty">No matches for \u201c' + esc(q) + '\u201d. Try a designer:</p><ul class="dp-ps-links">' +
          DP_POP.map(function (b) { return '<li><a href="' + base + 'collections/' + b[1] + '">' + esc(b[0]) + '</a></li>'; }).join('') + '</ul>';
      } else {
        if (s.length) h += '<ul class="dp-ps-q">' + s.map(function (x) { return '<li><a href="' + esc(clean(x.url) + '?q=' + encodeURIComponent(x.text) + '&type=product') + '"><span>' + hl(x.text, q) + '</span></a></li>'; }).join('') + '</ul>';
        if (c.length) h += '<p class="dp-ps-h">Designers &amp; collections</p><ul class="dp-ps-links">' + c.map(function (x) { return '<li><a href="' + esc(clean(x.url)) + '"><span>' + hl(x.title, q) + '</span></a></li>'; }).join('') + '</ul>';
        if (p.length) h += '<p class="dp-ps-h">Products</p><ul class="dp-ps-p">' + p.map(function (x) {
          var img = x.image ? x.image + (x.image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
          return '<li><a href="' + esc(clean(x.url)) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy">' : '<i></i>') +
            '<span><small>' + esc(x.vendor) + '</small><b class="dp-serif">' + hl(x.title, q) + '</b></span></a></li>';
        }).join('') + '</ul>';
        h += '<a class="dp-ps-all" href="' + esc(all) + '">View all results for \u201c' + esc(q) + '\u201d</a>';
      }
      box.innerHTML = h; box.hidden = false; main.classList.add('dp-ps-on');
    }
    function run() {
      var q = input.value.trim();
      if (q.length < 2) return off();
      if (cache[q]) return render(q, cache[q]);
      if (ctl) ctl.abort(); ctl = window.AbortController ? new AbortController() : null;
      fetch(base + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last', ctl ? { signal: ctl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (d) { var r = (d.resources && d.resources.results) || {}; cache[q] = r; if (input.value.trim() === q) render(q, r); })
        .catch(function () {});
    }
    input.addEventListener('input', function () { clearTimeout(timer); if (!input.value.trim()) return off(); timer = setTimeout(run, 200); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' && !box.hidden) { var a = box.querySelector('a'); if (a) { e.preventDefault(); a.focus(); } }
      if (e.key === 'Escape' && input.value) { e.preventDefault(); e.stopPropagation(); input.value = ''; off(); }
    });
    box.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var l = [].slice.call(box.querySelectorAll('a')), i = l.indexOf(document.activeElement);
      e.preventDefault(); i += e.key === 'ArrowDown' ? 1 : -1;
      if (i < 0) input.focus(); else if (l[i]) l[i].focus();
    });
    document.addEventListener('panel:closed', function () { setTimeout(function () { input.value = ''; off(); }, 300); });
  }
  function init() {
    var root = document.querySelector('[data-dp-menu]');
    var nav = document.getElementById('mobile-menu');
    if (!root || !nav || root.dataset.dpReady) return;
    root.dataset.dpReady = '1';
    nav.classList.add('dp-has-menu');
    renderRV(root);
    initPS(root);
    function closeSubs() { root.querySelectorAll('.dp-sub.is-open').forEach(function (p) { p.classList.remove('is-open'); }); }
    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-dp-open]');
      if (o) { var p = root.querySelector('[data-dp-panel="' + o.dataset.dpOpen + '"]'); if (p) { p.scrollTop = 0; p.classList.add('is-open'); pruneAZ(p); } return; }
      var b = e.target.closest('[data-dp-back]');
      if (b) { var s = b.closest('.dp-sub'); if (s) s.classList.remove('is-open'); return; }
      if (e.target.closest('[data-dp-close]')) {
        if (window.OverlayManager && OverlayManager.isOpen(nav)) OverlayManager.close(nav);
        else { var t = document.querySelector('.mobile-toggle-wrapper .mobile-toggle'); if (t) t.click(); }
      }
    });
    document.addEventListener('panel:open', function (e) { if (e.detail && e.detail.panel === nav) { document.body.classList.add('dp-menu-open'); stagger(root); renderRV(root); } });
    document.addEventListener('panel:closed', function (e) {
      if (e.detail && e.detail.panel === nav) { document.body.classList.remove('dp-menu-open'); root.classList.remove('dp-anim'); setTimeout(closeSubs, 300); }
    });
    var car = root.querySelector('[data-dp-car]'), dots = root.querySelectorAll('[data-dp-dots] i');
    if (car && dots.length) {
      car.addEventListener('scroll', function () {
        var cards = car.children, best = 0, bd = 1e9;
        for (var i = 0; i < cards.length; i++) { var d = Math.abs(cards[i].offsetLeft - car.offsetLeft - 20 - car.scrollLeft); if (d < bd) { bd = d; best = i; } }
        dots.forEach(function (d, i) { d.classList.toggle('on', i === best); });
      }, { passive: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
